import { render, staticRenderFns } from "./VisorEditable.vue?vue&type=template&id=5f34d38b&"
import script from "./VisorEditable.vue?vue&type=script&lang=ts&"
export * from "./VisorEditable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports